// extracted by mini-css-extract-plugin
export default {"content":"Ooa-z","title":"Poa-z","subTitle":"Qoa-z","banner":"Roa-z","productCardOverride":"Soa-z"};